import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(30, 20),
  gap: 20,
  width: "100%",
  backgroundColor: theme.palette.white,
  boxShadow: `0 2px 8px ${theme.palette.shadow.medium}`,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.border.light}`,

  [theme.down("sm")]: {
    ...theme.paddings(20, 15),
    gap: 15,
  },
}));

export const PassengersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,

  [theme.down("sm")]: {
    gap: 8,
  },
}));

export const CheckboxBlock = styled("div")(({ theme }) => ({
  display: "flex",
  gap: '12px',
  marginBottom: '24px',
  padding: '16px',
  background: theme.palette.gray[50],
  borderRadius: '4px',

  [theme.down("sm")]: {
    padding: '12px',
    gap: '10px',
    marginBottom: '16px',
  },
}));

export const AgreementText = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.primary,

  [theme.down("sm")]: {
    fontSize: 11,
  },
}));

export const AgreementBookLink = styled("span")(({ theme }) => ({
  color: theme.palette.secondary.light,
  cursor: "pointer",
}));

export const SubmitBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
}));

export const Button = styled("button")(({ theme }) => ({
  ...theme.paddings(0, 15),
  ...theme.mixins.flexCenterCenter,
  gap: 10,
  position: "relative",
  border: "none",
  backgroundColor: theme.palette.searchButtonBg,
  cursor: "pointer",
  height: 50,
  fontSize: 18,
  fontWeight: 600,
  color: theme.palette.white,
  borderRadius: 8,
  transition: "all 0.3s ease",

  "&:disabled": {
    opacity: 0.6,
    cursor: "not-allowed",
  },

  "&:not(:disabled):hover": {
    transform: "translateY(-2px)",
    boxShadow: `0 4px 12px ${theme.palette.secondary.focusShadow}`,
  },

  [theme.down("sm")]: {
    fontSize: 16,
    height: 46,
  },
}));
